import * as React from 'react';
import { Route, Router } from 'react-router-dom';

import { history } from '../../helpers/history';
import Layout from '../layout/LayoutUI';
import HomeUI from '../home/HomeUI';
import UEFADeclarationForm from '../uefa/UEFADeclarationForm';
import Covid19Declaration from '../covid19/Covid19Declaration';
import 'bootstrap/dist/css/bootstrap.min.css';
import './AppFrameStyle.scss';
import { Container } from 'react-bootstrap';

class AppFrame extends React.Component<{}, {}> {
    constructor(props: any) {
        super(props);

        history.listen((location, action) => {

        });
    }

    public render() {
        return (
            <div>
                <Router history={history}>
                    <Layout>
                        <Container className="appframe">
                            <Route exact={true} path={'/'} component={HomeUI} />
                            <Route path={'/uefadeclaration'} component={UEFADeclarationForm} />
                            <Route path={'/covid19declaration'} component={Covid19Declaration} />
                        </Container>
                    </Layout>
                </Router>
            </div>
        );
    }
}

export default AppFrame;